import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=5b9a2cc4&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
import style0 from "./Create.vue?vue&type=style&index=0&id=5b9a2cc4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9a2cc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b9a2cc4')) {
      api.createRecord('5b9a2cc4', component.options)
    } else {
      api.reload('5b9a2cc4', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=5b9a2cc4&scoped=true", function () {
      api.rerender('5b9a2cc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/standardphone/Create.vue"
export default component.exports